import { useMemo } from 'react'
import { useMapSection } from '../context'
import { getLayerConfigs, DynamicLayerConfig } from '../config'

/**
 * Hook to get layer configurations for the active section
 *
 * Returns an array of layer configs that should be displayed
 * in the dynamic layers group based on the current section.
 */
export const useSectionLayers = (): DynamicLayerConfig[] => {
  const { getActiveSectionLayers } = useMapSection()

  const layerConfigs = useMemo(() => {
    const layerIds = getActiveSectionLayers()
    return getLayerConfigs(layerIds)
  }, [getActiveSectionLayers])

  return layerConfigs
}
